import { sv } from "../../../../date-fns/locale/sv.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    sv
  }
};